;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"3345d32864e27ad2ac892291cd5912bbf1f219db"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { redactPublicInvitationData } from "@/lib/public-invitation-telemetry";
import * as Sentry from "@sentry/nextjs";

import { clientSentryRelease } from "@/lib/sentry-release";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: 0.1,
  beforeSendTransaction: redactPublicInvitationData,
  release: clientSentryRelease(),
  beforeSend: redactPublicInvitationData,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === "console" && breadcrumb.level === "debug") {
      return null;
    }
    return redactPublicInvitationData(breadcrumb);
  },
});
